import React from 'react';
import { FaTimes } from 'react-icons/fa';
import WeeklyStudentsPanel from '../Trainees/WeeklyStudentsPanel';
import '../OJTCoordinator.css';
import './ProgramStat.css';

interface WeeklyTrainee {
  name: string;
  department: string;
  weeklyHours: number;
  status: 'At Risk' | 'Not At Risk';
  riskScore?: number;
  attendanceRate?: number;
  absentRate?: number;
  holidayRatio?: number;
}

// Card Component
interface AtRiskStudentsCardProps {
  count: number;
  onClick: () => void;
}

export const AtRiskStudentsCard: React.FC<AtRiskStudentsCardProps> = ({ count, onClick }) => {
  return (
    <div className="stat-card clickable" onClick={onClick}>
      <div className="stat-number">{count}</div>
      <div className="stat-label">At Risk Students</div>
    </div>
  );
};

// Modal Component
interface AtRiskStudentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  weeklyTrainees: WeeklyTrainee[];
  loading: boolean;
}

export const AtRiskStudentsModal: React.FC<AtRiskStudentsModalProps> = ({
  isOpen,
  onClose,
  weeklyTrainees,
  loading,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content students-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Students Risk Overview - All Students</h2>
          <button className="close-modal-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        <div className="modal-body">
          <WeeklyStudentsPanel 
            trainees={weeklyTrainees} 
            loading={loading}
            filterAtRisk={false}
          />
        </div>
      </div>
    </div>
  );
};

